import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { ReactComponent as PathwayLogo } from "../../assets/images/logos/logo-wsb.svg";
import logo from "../../assets/images/logo.png";

import { Box, Typography } from "@mui/material";

export const Logo = styled((props) => {
    const { variant, ...other } = props;

    const color = variant === "light" ? "#C1C4D6" : "#5048E5";

    return (
        <Box sx={{ p: 3, width: "300px", color: "white" }}>
            <img src={logo} alt="logo" style={{ height: "50px" }}></img>
        </Box>
    );
})``;

Logo.defaultProps = {
    variant: "primary",
};

Logo.propTypes = {
    variant: PropTypes.oneOf(["light", "primary"]),
};
